/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { User } from '@/client';
import { useAuthorization } from '@/hooks/useAuthorization';

export type GuardedComponentProps = {
  requiredRole: User['role'];
  children: React.ReactNode;
};

export function GuardedComponent({ requiredRole, children }: GuardedComponentProps) {
  const isAuthorized = useAuthorization(requiredRole);

  if (!isAuthorized) return null;

  return children;
}
